export const DEFAULT_THRESHOLD_NORMAL = 768
export const DEFAULT_THRESHOLD_WIDE = 1200
export const DEFAULT_IFRAME_HEIGHT = 800



// WEBPACK FOOTER //
// ./src/constants/layout.js